import Row from '../../utils/StyledRow'
import { SIZES } from '../../../constants'

export default Row.extend`
  @media (min-width: ${SIZES.BREAKPOINT_MD}px) {
    margin-top: 15px;
  }
`
